import { Component, OnInit, Inject, ViewChild, TemplateRef, Output, EventEmitter, Input, Injector } from '@angular/core';
import IdentificationTypesListComponentView from './identification-types-list.component.html';
import { ConfirmationService } from 'primeng/api';
import { TranslateService, _ } from '@ngx-translate/core';
import { AuthService } from '../../../../core/services/auth.service';
import { LogService } from '../../../../core/services/log.service';
import { IdentificationType } from '../../../../shared/models/common/identification-type.model';
import { IdentificationTypesService } from '../../services/identification-types.service';
import { Table } from 'primeng/table';
import { GridConfig } from '../../../../shared/components/grid/models/grid-config.model';

@Component({
    selector: 'identification-types-list',
    template: IdentificationTypesListComponentView
})

export class IdentificationTypesListComponent implements OnInit {

    @ViewChild('activeTemplate', { static: true }) activeTemplate!: TemplateRef<any>;
    @ViewChild('personalTemplate', { static: true }) personalTemplate!: TemplateRef<any>;

    private allowWrite: boolean = false;

    private gridConfig: GridConfig = {
        columns: []
    };

    private searchValue: string = '';

    private identificationTypes: IdentificationType[];

    private getIdentificationTypes() {
        this.identificationTypesService.getAllIdentificationTypes().subscribe({
            next: (IdentificationTypesData) => {
                this.identificationTypes = IdentificationTypesData;
            },
            error: (err) => {
                console.error('Something went wrong... ', err);
            }
        })
    };

    private goToAdd() {
        this.$state.go("common.identificationtypes.edit");
    }

    private goToEdit(id) {
        // TODO Makinga a confirm modal
        this.$state.go("common.identificationtypes.edit", { id: id });
    }

    private checkDelete(identificationType) {

        this.confirmationService.confirm({
            message: this.translate.instant(_('identificationtypes.check_delete')),
            header: this.translate.instant(_('general.remove')), 
            accept: () => {
                this.identificationTypesService.deleteIdentificationType(identificationType).subscribe({
                    next: () => this.getIdentificationTypes(),
                });
            },
            reject: () => {
                // Optional: action on reject (cancel)
            }
        });

    }
    constructor(@Inject(LogService) private log: LogService,
        @Inject(IdentificationTypesService) private identificationTypesService: IdentificationTypesService,
        @Inject(ConfirmationService) private confirmationService: ConfirmationService,
        @Inject(TranslateService) private translate: TranslateService,
        @Inject(AuthService) private authService: AuthService,
        @Inject('$stateParams') private $stateParams: any,
        @Inject('$state') private $state: any) {
    }

    ngOnInit() {

        this.allowWrite = true  // this.authService.permissionExist('LANGUAGES_WRITE') ?? false;

        this.getIdentificationTypes();
        this.identificationTypesService.showServiceMessage();

    }

    ngAfterViewInit() {

        this.gridConfig = {

            columns: [

                {
                    name: 'Name',
                    header: { displayName: 'general.name' },
                    type: 'text',
                    enableSorting: true,
                },
                {
                    name: 'Description',
                    header: { displayName: 'general.description' },
                    type: 'text',
                    enableSorting: true,
                },
                {
                    name: 'CountryName',
                    header: { displayName: 'general.country' },
                    type: 'text',
                    enableSorting: true,
                },
                {
                    name: 'Personal',
                    header: { displayName: 'identification_types.personal' },
                    template: this.personalTemplate,
                    enableSorting: true,
                },
                {
                    name: 'Active',
                    header: { displayName: 'general.active', style: 'width: 150px; text-align: center;' },
                    template: this.activeTemplate,
                    enableSorting: true,
                }

            ],
            actions: [

                {

                    label: 'general.edit',
                    icon: 'pi-pen-to-square',
                    command: (row) => this.goToEdit(row.id),
                    showCondition: (row) => this.allowWrite

                },

                {
 
                     label: 'general.remove',
                     icon: 'pi pi-times',
                     severity: 'danger',
                     command: (row) => this.checkDelete(row),
                     showCondition: (row) => true
 
                }
                 
            ],

            globalFilterFields: ['name', 'active'],
            resizableColumns: true,
            sortMode: 'single',
            stateStorage: 'local',
            stateKey: 'identificationtypesTable',
            enableSelection: false,
            sortField: 'name',
            sortOrder: -1,
            dataKey: 'id',
            customSort: false,
            showColumnSelector: false,
            showClearButton: false,
            showExportButton: false,
            showRefreshButton: true,

            refreshCallback: () => {

                this.identificationTypesService.getAllIdentificationTypes();

            }

        };
    }

    clear(table: Table) {

        table.clear();
        table.filters = {}

    }

}
